
import { Stack, Box, Chip } from '@mui/material'
import { format } from 'date-fns'
import { localeOrdinalMonthFormat } from '../../../utils/localeUtils'
import { BookingPopover } from './components'
import ButtonSmall from '../../../shared/UI/ButtonSmall'
import Tab from '../../../shared/UI/Tab'
import localCss from '../booking.module.css'
import Paragraph from '../../../shared/UI/Paragraph'
import PopoverWrapper from './PopoverWrapper'


function HeaderTabContent (props: PopoverWrapper) {
  const { tabSelectionProps } = props
  if (tabSelectionProps.length === 1) {
    return tabSelectionProps[0].tabContext
  }
  return <Tab
    titleAndContent={props.tabSelectionProps}
    tabClass={localCss.bookingPopover}
    onChange={idx => props.setSelectedTab(idx)}
    isMobile={props.isMobile}
    removeInactiveArrows
    hideIndicator
    sx={{
      '& .MuiTab-root': {
        paddingTop: 0,
        fontWeight: '400',
      },
      '&': {
        paddingBottom: '8px'
      },
    }}
  />
}

function BookingPopoverComponent (props: any) {
  return (
    <BookingPopover
      isMobile={props.isMobile}
      popoverPosition={props.popoverPosition}
      popupWidth={props.popoverWidth}
      isOwnBooking={props.isOwnBooking}
    >
      {!props.isOwnBooking && props.isMobile && <Box marginTop="20px" />}
      <Stack direction="row" justifyContent='space-between' alignItems='center'>
        <Paragraph size="14px" weight="medium-bold" color="black">{props.deskLabel}</Paragraph>
        <Chip
          label={props.availability.text}
          sx={{ 
            color: props.availability.chipTextColor,
            backgroundColor: props.availability.backgroundColor,
            fontWeight: 'bold',
            height: '24px',
            borderRadius: '8px',
            '.MuiChip-label': {
              padding: '4px 6px',
              fontSize: '11px'
            }
           }} 
        />
      </Stack>
      { props.showDate &&
        <Paragraph color="rgba(0, 0, 0, 0.44)" size="11px">
          {format(props.date, `${localeOrdinalMonthFormat} yyyy`)}
        </Paragraph>
      }
      <Box marginTop="16px"><HeaderTabContent {...props} /></Box>
      <Stack
        direction="row"
        justifyContent="space-between"
        sx={{
          width: '100%',
          left: '0',
          boxSizing: 'border-box',
          bottom: props.isMobile ? '64px' : '24px',
          marginTop: '24px',
          minHeight: '26.25px'
        }}
      >
        {!props.isMobile && <ButtonSmall
          color="primary"
          label="Close"
          variant="text"
          minWidth='0'
          sx={{ fontSize: '11px', margin: '0', padding: '0px 4px' }}
          onClick={props.onClickCallback}
        />}
        {props.getSubmitLabel() !== 'Disabled'
          &&
          <ButtonSmall
            label={props.getSubmitLabel()}
            minWidth={props.isMobile ? "100%" : "88px"}
            sx={{
              ...(
                props.isMobile ? {
                  padding: '15px 25px',
                  fontSize: '16px',
                  margin: '0px auto'
                } : {
                  padding: '1.5px 30px',
                  fontSize: '11px',
                  margin: '0'
                }
              ), ...{
                  opacity: props.getSubmitDisabledState() ? 0.5 : 1,
                }
            }}
            disabled={props.getSubmitDisabledState()}
            onClick={props.onButtonClick}
          />
        }
      </Stack>
    </BookingPopover>
  )
}


export default BookingPopoverComponent
